import { Box, List, VStack, Flex, Heading, Text, Button } from "@chakra-ui/react";
import { AltArrowForward } from "@airhelp/icons";
import { RichtextAdapter } from "modules/storyblok/adapters";
import { useEffect, useState } from "react";
import type { SbEditableComponentProps } from "types/storyblok";
import type { ContentItem, TextSwitcherProps } from "./TextSwitcher.d";

const TextSwitcher = ({ heading, content, text, sbEditable }: SbEditableComponentProps<TextSwitcherProps>) => {
  const [firstItem] = content;
  const initValue = firstItem?.itemContent || null;
  const [activeItem, setActiveitem] = useState<ContentItem["itemContent"] | null>(initValue);

  useEffect(() => {
    if (initValue) return setActiveitem(initValue);

    setActiveitem(null);

    return () => {
      setActiveitem(null);
    };
  }, [initValue]);

  const handleOnClick = (item: ContentItem["itemContent"]) => setActiveitem(item);

  return (
    <Flex alignItems="center" flexDir={{ base: "column", lg: "row" }} {...sbEditable}>
      <Flex flex={1} flexDir="column" align="left">
        {heading && (
          <Heading variant="h2" as="h2" mb={6}>
            {heading}
          </Heading>
        )}
        {text && <Text mb={10}>{text}</Text>}
        <List>
          <VStack spacing={{ base: 4, lg: 6 }} align="left">
            {content.map(({ itemContent, triggerText }) =>
              triggerText ? (
                <Button
                  as="li"
                  variant="unstyled"
                  minH="auto"
                  key={triggerText}
                  onClick={() => handleOnClick(itemContent)}
                  cursor="pointer"
                  display="flex"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >
                  <AltArrowForward color="primary.500" mr={{ base: 2, lg: 4 }} />
                  <Text fontSize="md" fontWeight="bold">
                    {triggerText}
                  </Text>
                </Button>
              ) : null
            )}
          </VStack>
        </List>
      </Flex>
      <VStack flex={1} align="left" ml={{ base: 0, lg: 20 }} mt={{ base: 12, lg: 0 }}>
        {activeItem && (
          <Box boxShadow={{ base: "none", lg: "alt" }} p={{ base: 0, lg: 10 }} borderRadius="xl">
            <RichtextAdapter
              content={activeItem}
              customStyles={{
                heading: { mb: 4 },
                link: { mt: { base: 6, lg: 8 }, display: "block", _visited: {} },
              }}
            />
          </Box>
        )}
      </VStack>
    </Flex>
  );
};

export default TextSwitcher;
